import React, { useState } from "react";

import PropTypes from "prop-types";

import BolaNmero from "./bola-nmero";
import BolaNmeroAtiva from "./bola-nmero-ativa";
import "./slider.css";

const Slider = (props) => {
  const [titulo, setTitulo] = useState(
    "Soluções financeiras completas para você que tem muito para conquistar!",
  );
  const [numeroAtivo, setNumeroAtivo] = useState("01.");
  const [ativo, setAtivo] = useState(1);
  const [descricao, setDescricao] = useState(
    "Você conta com produtos e serviços seguros e personalizados para realizar os seus sonhos. E conta com um atendimento próximo e acolhedor para entender a real necessidade de cada momento da sua vida.",
  );
  return (
    <div className={`slider-container ${props.rootClassName} `}>
      <img
        alt="image"
        src="/lp/economiadacooperacao/Secao3/fundo%20circular-1700w.png"
        className="slider-image"
      />
      <div className="slider-container1">
        <span className="slider-text Exo2-H4">{numeroAtivo}</span>
        <span className="slider-text1 Exo2-T1">{titulo}</span>
        <span className="slider-text2 Exo2-T2">{descricao}</span>
      </div>
      {ativo === 1 && (
        <div className="slider-bola-1-ativo">
          <BolaNmeroAtiva
            numero="01"
            rootClassName="bola-nmero-ativa-root-class-name4"
          ></BolaNmeroAtiva>
        </div>
      )}
      <div
        onClick={() => {
          setTitulo(
            "Soluções financeiras completas para você que tem muito para conquistar! ",
          );
          setDescricao(
            "Na Viacredi você encontra produtos e serviços seguros e personalizados para realizar os seus sonhos. E ainda conta com um atendimento próximo e acolhedor para entender a real necessidade de cada momento da sua vida.",
          );
          setAtivo(1);
          setNumeroAtivo("01.");
        }}
        className="slider-bola-1"
      >
        <BolaNmero
          numero="01"
          rootClassName="bola-nmero-root-class-name1"
        ></BolaNmero>
      </div>
      {ativo === 2 && (
        <div className="slider-bola-2-ativo">
          <BolaNmeroAtiva
            numero="02"
            rootClassName="bola-nmero-ativa-root-class-name5"
          ></BolaNmeroAtiva>
        </div>
      )}
      <div
        onClick={() => {
          setAtivo(2);
          setDescricao(
            "Todos os anos realizamos uma pesquisa para saber a diferença de taxas, tarifas, juros e rentabilidade da Viacredi quando comparada às demais instituições financeiras. Esse valor que você deixou de pagar em taxas, juros e tarifas ou que recebeu a mais em rentabilidade nos seus investimentos, fica no seu bolso. Assim o seu poder de compra aumenta e impacta toda a comunidade. Fonte dos dados: Banco Central, Febraban e AMBIMA.",
          );
          setNumeroAtivo("02.");
          setTitulo("Economize e tenha mais rentabilidade com a cooperativa");
        }}
        className="slider-bola-2"
      >
        <BolaNmero
          numero="02"
          rootClassName="bola-nmero-root-class-name5"
        ></BolaNmero>
      </div>
      {ativo === 3 && (
        <div className="slider-bola-3-ativo">
          <BolaNmeroAtiva
            numero="03"
            rootClassName="bola-nmero-ativa-root-class-name7"
          ></BolaNmeroAtiva>
        </div>
      )}
      <div
        onClick={() => {
          setDescricao(
            "O valor gerado pela Economia da Cooperação fomenta o surgimento de novos negócios, promove a criação de novas oportunidades de trabalho que consequentemente, impacta de forma positiva na renda das pessoas, criando um ciclo virtuoso que desenvolve toda a economia local.",
          );
          setNumeroAtivo("03.");
          setTitulo("Juntos criamos novas oportunidades em um ciclo sem fim");
          setAtivo(3);
        }}
        className="slider-bola-3"
      >
        <BolaNmero
          numero="03"
          rootClassName="bola-nmero-root-class-name7"
        ></BolaNmero>
      </div>
    </div>
  );
};

Slider.defaultProps = {
  rootClassName: "",
};

Slider.propTypes = {
  rootClassName: PropTypes.string,
};

export default Slider;
